/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:start;justify-content:flex-start;-webkit-box-align:center;align-items:center;padding-top:40px}[_nghost-%COMP%]   .title[_ngcontent-%COMP%]{-ms-grid-row-align:start;align-self:start;margin-left:15px;color:#0080ff;font-size:1.8rem;font-weight:700}[_nghost-%COMP%]   .lc-onboarding-iframe[_ngcontent-%COMP%]{width:100%;min-height:720px}[_nghost-%COMP%]   .lc-onboarding-iframe-lfa[_ngcontent-%COMP%]{min-height:770px}@media (min-width:992px){[_nghost-%COMP%]   .lc-onboarding-iframe[_ngcontent-%COMP%]{min-height:630px}}@media (min-width:992px){[_nghost-%COMP%]   .title[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
//# sourceMappingURL=lc-onboarding-iframe.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/lc-onboarding-iframe/lc-onboarding-iframe.component.scss.shim.ngstyle.js
// module id = 1571
// module chunks = 27 28 29